export type UrlObjectParams = {
  [paramName: string]: string,
};

export function fixUrlsToLocalProtocol<T>(url: T) {
  const localUrls: Record<string, string> = {};

  for (const name in url) {
    localUrls[name] = fixUrlLocalProtocol(url[name] as string);
  }

  return localUrls as T;
}

export function fixUrlLocalProtocol(url: string) {
  try {
    const localUrl = new URL(url);
    
    localUrl.protocol = location.protocol;

    return localUrl.toString();
  } catch {
    return url;
  }
}

export function addParamsToUrl(url: string, params: UrlObjectParams = {}) {
  const urlObject = new URL(url, location.origin);

  for (const paramName of Object.keys(params)) {
    urlObject.searchParams.set(paramName, params[paramName]);
  }

  return urlObject.toString();
}

export function getLocationParam(paramName: string) {
  const urlObject = new URL(window.location.href);

  return urlObject.searchParams.get(paramName);
}

export function openUrl(url: string) {
  window.location.href = url;
}
